import './App.css';
import Main from './components/MainComponent';

import React, {useEffect} from 'react';

import { BrowserRouter } from 'react-router-dom';


//functions
import { currentUser, currentAdmin, currentBobza } from './functions/auth/auth'

//import auth from firebase
import {firebaseApp} from './firebase'
import {onIdTokenChanged} from 'firebase/auth';

//redux
import {useDispatch} from 'react-redux'



function App() {

  const dispatch = useDispatch()

  //to check firebase auth state
  useEffect(() =>{ 
    //onauthstatechanged, onIdTokenChanged is from firebase 
    const unsubscribe = onIdTokenChanged(firebaseApp, async (user) =>{   
      if(user){  
        if(user.emailVerified === false){
          //user.sendEmailVerification();
          return
        }
          //console.log("AUTH STATE", user)
          const idTokenResult= await user.getIdTokenResult()
          //console.log("User Claims",idTokenResult.claims.type)
          if (idTokenResult.claims.type==="normal"){
            currentUser(idTokenResult.token)
              .then((res) => {
                dispatch({
                  type: 'LOGGED_IN_USER',
                  payload: {
                    token: idTokenResult.token,
                    firstName: res.data.firstName,
                    lastName: res.data.lastName,
                    email: res.data.email,
                    number:res.data.number,
                    gender: res.data.gender,
                    role: res.data.role,
                    _id: res.data._id,
                    claim: idTokenResult.claims.type,
                    address: res.data.address
                  }
                })
              })
            .catch(err=> console.log(err));   
        }else if(idTokenResult.claims.type==="admin"){

          //write out the code to fetch current admin
            currentAdmin(idTokenResult.token)
              .then((res) => {
                dispatch({
                  type: 'LOGGED_IN_Admin',
                  payload: {
                    //comes from firebase but now db
                    //email: user.email,
                    token: idTokenResult.token,
                    name: res.data.name,
                    number: res.data.number,
                    description: res.data.description,
                    email: res.data.email,
                    status: res.data.status,
                    role: res.data.role,
                    _id: res.data._id,
                    address: res.data.address,
                    images: res.data.images,
                    trial:res.data.trial,
                    social: res.data.social,
                    claim: idTokenResult.claims.type,

                  }
                })
              })
              .catch(err => console.log(err));
        }else{

         
          currentBobza(idTokenResult.token)
          .then((res) => {
            dispatch({
              type: 'LOGGED_IN_Bobza',
              payload: {
                token: idTokenResult.token,
                    firstName: res.data.firstName,
                    lastName: res.data.lastName,
                    email: res.data.email,
                    role: res.data.role,
                    _id: res.data._id,
                    claim: idTokenResult.claims.type,
              }
            })
          })
          .catch(err => console.log(err));
        }
         
       
      }
    })

    //clean up

    return () => unsubscribe;
  }, [dispatch])

  

  return (
    <div className="App">
      

     
      <BrowserRouter>
        <div>
          <Main/> 
        </div>
      </BrowserRouter>
      
    </div>
  );
}

export default App;
